import React, { useState } from "react";
import { BlobServiceClient } from '@azure/storage-blob';
import { useQuery } from '@apollo/client';
import { GENERATE_SAS_TOKEN } from '../../../apollo/queries';
import { Button } from '../Button';
import styles from "./FileUpload.module.scss";

// @ts-ignore
async function uploadImage(containerName: string, sasToken: string, valueChanged: Function, file) {
    const url =   `${process.env.REACT_APP_AZURE_STORAGE_URL}${sasToken}`
    const blobServiceClient = new BlobServiceClient(url);
    const now = new Date().toISOString().substring(0, 19)
    const bits = file.name.split('.')
    bits.splice(bits.length - 1, 0, now)
    let fileName = bits.join('.')

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(fileName);
    const blockBlobClient = blobClient.getBlockBlobClient();
    const result = await blockBlobClient.uploadData(file, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
        onProgress: ev => console.log(ev)
    });

    const uploadFileUrl = blobClient.url.split('?')[0]
    console.log(`Upload of file '${file.name}' completed to location ${uploadFileUrl}`);

    valueChanged(uploadFileUrl)

    return uploadFileUrl
}

interface FileUploadInput {
    value?: string
    label?: string
    valueChanged: Function
}

export const FileUpload = ({
    value,
    label,
    valueChanged
}: FileUploadInput) => {
    const [file, setFile] = useState(null);
    const [sasToken, setSasToken] = useState(null);

    useQuery(GENERATE_SAS_TOKEN, {
        onCompleted: (someData) => {
            setSasToken(someData.generateSASToken)
        },
        fetchPolicy: "no-cache"
    });

    // @ts-ignore
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    // @ts-ignore
    const onClick = () => {
        // @ts-ignore
        uploadImage("public", sasToken, valueChanged, file);
    };

    return (
        <div className={styles.wrapper}>
            { label && (
                <label className={styles.label}>{label}</label>
            )}
            <input className={styles.uploadInput} type="file" onChange={handleFileChange} />
            <Button className="dark" type="button" onClick={onClick}>Upload Image</Button>
        </div>
    );
}
